import React from 'react';
import { Text, Divider } from '@lana-ui/common';
import '@styles/Features/plan-checkout.scss';

const PlanCheckout = ({ precioTotal }) => {
    return (
        <div className="plan-checkout">
            <Text as="p" className="--arial" size="2xs">
                <span className="descripcion">PLAN ANUAL</span>
                <span>${precioTotal}</span>
            </Text>

            <Divider className="--mb-8" />

            <Text as="p" className="--arial --font-bold" size="2xs">
                <span className="descripcion">Total</span>
                <span>${precioTotal}</span>
            </Text>
        </div>
    );
};

export default PlanCheckout;
